import React from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

export const getGroupedByStatus = (listItemsDisable) => {
    const grouped = {}
    listItemsDisable.forEach(item => {
        if (!grouped[item.production_status]) grouped[item.production_status] = []
        grouped[item.production_status].push(item)
    })
    return grouped
}

// extraGroups: optional list of custom disable reasons that are not grouped by production_status.
// Each item: { key, items, tooltipText, reason } where `reason` is JSX rendered in the modal header.
export const getTooltipContent = (listItemsHasLabel, listItemsDisable, openModalFn, extraGroups = []) => {
    const grouped = getGroupedByStatus(listItemsDisable)
    return (
        <div>
            {listItemsHasLabel.length > 0 && (
                <div>
                    <span className="cursor-pointer text-primary" onClick={() => openModalFn('hasLabel')}>{listItemsHasLabel.length}</span>
                    {' Barcode đang gen label theo luồng mới ở FFM'}
                </div>
            )}
            {listItemsDisable.length > 0 && Object.keys(grouped).map(status => (
                <div key={status}>
                    <span className="cursor-pointer text-primary" onClick={() => openModalFn(status)}>{grouped[status].length}</span>
                    {` Barcode đang ở trạng thái `}<strong>{status}</strong>
                </div>
            ))}
            {extraGroups.map(group => group.items.length > 0 && (
                <div key={group.key}>
                    <span className="cursor-pointer text-primary" onClick={() => openModalFn(group.key)}>{group.items.length}</span>
                    {` ${group.tooltipText}`}
                </div>
            ))}
        </div>
    )
}

export const getModalContent = (modalType, showModal, listItemsHasLabel, listItemsDisable, closeModalFn, extraGroups = []) => {
    const grouped = getGroupedByStatus(listItemsDisable)
    const extraGroup = extraGroups.find(group => group.key === modalType)
    let modalItems, reason
    if (modalType === 'hasLabel') {
        modalItems = listItemsHasLabel
        reason = <><strong>gen label theo luồng mới ở FFM</strong></>
    } else if (extraGroup) {
        modalItems = extraGroup.items
        reason = extraGroup.reason
    } else {
        modalItems = grouped[modalType] || []
        reason = <>Đang ở trạng thái <strong>{modalType}</strong></>
    }

    const totalColumns = Math.max(1, Math.ceil(modalItems.length / 20))

    return (
        <Modal isOpen={showModal} toggle={closeModalFn}>
            <ModalHeader toggle={closeModalFn}>Danh sách barcode đã chọn - {reason}</ModalHeader>
            <ModalBody>
                <div style={{
                    columnCount: totalColumns,
                }}>
                    {modalItems.map(item => <div key={item._id} style={{ breakInside: 'avoid' }}>#{item.barcodeNumber}</div>)}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={closeModalFn}>Đóng</Button>
            </ModalFooter>
        </Modal>
    )
}
